







import { Vue, Component } from 'vue-property-decorator';
import DashboardServices from '@/services/dashboard';
import { getRange } from '@/libs/time';
import { sleep } from '@/libs/util';
import DictMixin from '@/mixins/dict-mixin';
import { mixins } from 'vue-class-component';
import { Action } from 'vuex-class';
@Component({
  components: {}
})
export default class RankingBoard extends mixins(DictMixin) {
  @Action('getDictList') getDictList: any;
  dashSrv = new DashboardServices();

  config: any = {
    data: [],
    rowNum: 8
  };

  created() {
    let [startTime, endTime] = getRange('total');
    this.getCustomerJourney({ startTime, endTime });
  }

  async getCustomerJourney(params?: any) {
    let scene = this.SYS_DICT.DICT_JOURNEY_SCENE;
    if (!scene) {
      await this.getDictList();
      await sleep(100);
      this.getCustomerJourney(params);
      return false;
    }
    let list = await this.dashSrv.getCustomerJourney(params);
    this.config.data = list.map((v: any) => {
      return {
        name: v.name,
        value: v.total
      };
    });
    scene.forEach((v: any) => {
      if (!this.config.data.find((c: any) => c.name === v.dictItemName)) {
        this.config.data.push({
          name: v.dictItemName,
          value: 0
        });
      }
    });
  }
}
